/*jshint esversion: 6 */
/*jshint strict:false */

const getDefaultState = () => {
    return {
        loading: true,
        loadingMessage: '',
        reference: '',
        bank_selected: false,
        bankId: '',
        banks: [],
        qrcode: '',
        redirectUrl: '',
        stage: 'initial'
    };
};

const state = getDefaultState();

const mutations = {
    setLoading(state, value) {
        state.loading = value;
    },
    setReference(state, reference) {
        state.reference = reference;
    },
    setLoadingMessage(state, message) {
        state.loadingMessage = message;
    },
    toggleBankSelected(state) {
        state.bank_selected = !state.bank_selected;
    },
    setBankId(state, id) {
        state.bankId = id;
    },
    setBanks(state, banks) {
        state.banks = banks
    },
    setQrCode(state, code) {
        state.qrcode = code;
    },
    setRedirectUrl(state, url) {
        state.redirectUrl = url;
    },
    setStage(state, stage) {
        state.stage = stage;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
    setLoading({commit}, value) {
        commit('setLoading', value);
    },
    setReference({commit}, reference) {
        commit('setReference', reference);
    },
    setLoadingMessage({commit}, message) {
        commit('setLoadingMessage', message);
    },
    toggleBankSelected({commit}) {
        commit('toggleBankSelected');
    },
    setBankId({commit}, id) {
        commit('setBankId', id);
    },
    setBanks({commit}, banks) {
        commit('setBanks', banks);
    },
    setQrCode({commit}, code) {
        commit('setQrCode', code);
    },
    setRedirectUrl({commit}, url) {
        commit('setRedirectUrl', url);
    },
    setStage({commit}, stage) {
        if(!['initial', 'processing', 'expired', 'status-update'].includes(stage)) {
            return;
        }

        commit('setStage', stage);
    },
    resetState({commit}) {
        commit('resetState');
    }
};

const getters = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};